import { render, staticRenderFns } from "./PFLoanAwatingDisbursementReport.vue?vue&type=template&id=28c9f186"
import script from "./PFLoanAwatingDisbursementReport.vue?vue&type=script&lang=js"
export * from "./PFLoanAwatingDisbursementReport.vue?vue&type=script&lang=js"
import style0 from "./PFLoanAwatingDisbursementReport.vue?vue&type=style&index=0&id=28c9f186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports